/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Keycloak from 'keycloak-js';

const {
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_CLIENT_ID,
} = process.env;

if (
  !REACT_APP_KEYCLOAK_URL ||
  !REACT_APP_KEYCLOAK_REALM ||
  !REACT_APP_KEYCLOAK_CLIENT_ID
) {
  console.error('Keycloak env vars are missing');
}

const keycloak = new Keycloak({
  url: `${REACT_APP_KEYCLOAK_URL}`, // acrescenta /auth se for Keycloak <21; ajuste se 25 já usa root
  realm: REACT_APP_KEYCLOAK_REALM!,
  clientId: REACT_APP_KEYCLOAK_CLIENT_ID!,
});

export default keycloak;
